import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=178b240d&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178b240d')) {
      api.createRecord('178b240d', component.options)
    } else {
      api.reload('178b240d', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=178b240d&", function () {
      api.rerender('178b240d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hFCXK7G64gei/JS/videoIframe.vue"
export default component.exports